<div class="menu-item-content">
  <hyperkit-typography variant="body1" align="left" color="inherit">{{label}}</hyperkit-typography>
</div>